export default class Tabs {
  constructor(element) {
    this.element = element;
    this.triggers = [...this.element.querySelectorAll('[data-tabs-trigger]')];
    this.panels = [...this.element.querySelectorAll('[data-tabs-panel]')];

    if (!this.triggers.length || !this.panels.length) {
      return;
    }

    this.init();
  }

  init() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.activate(trigger.dataset.tabsTrigger);
      });
    });

    const activeTrigger = this.triggers.find((trigger) => trigger.classList.contains('is-active')) || this.triggers[0];
    this.activate(activeTrigger.dataset.tabsTrigger);
  }

  activate(id) {
    this.triggers.forEach((trigger) => {
      const isActive = trigger.dataset.tabsTrigger === id;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-selected', String(isActive));
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.tabsPanel === id;
      panel.classList.toggle('is-active', isActive);
      panel.toggleAttribute('hidden', !isActive);
    });
  }
}
